import { NotificationShopPreferencesApiClient } from '@fourthwall/services/dist/NotificationShopPreferencesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useNotificationShopPreferencesMutation = createMutationHook(
  NotificationShopPreferencesApiClient.updateNotificationShopPreferences,
  {
    mutationKey: ['notificationShopPreferences'],
  },
)
